import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../auth";
import { formatError } from "../api";
import { Button, Card } from "../ui";

export default function ChangePassword() {
  const { changePassword, logout, mustChange } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [conf, setConf] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (nw !== conf) return toast.error("Passwords do not match");
    if (nw.length < 10) return toast.error("Password must be at least 10 characters");
    setBusy(true);
    try {
      await changePassword(cur, nw);
      toast.success("Password updated.");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[hsl(var(--aoa-gray-bg))] px-5" data-testid="admin-change-password-page">
      <Card className="w-full max-w-md p-8">
        <div className="text-center mb-6">
          <img src="/logos/aoa_logo_royal_blue.png" alt="AOA" className="h-12 w-12 object-contain mx-auto" />
          <h1 className="mt-4 font-display text-xl font-bold text-[hsl(var(--aoa-navy))]">
            {mustChange ? "Set a new password" : "Change password"}
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            {mustChange ? "First-time login requires a fresh password." : "Use a strong, unique password."}
          </p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-change-password-form">
          <Field label="Current password" type="password" value={cur} onChange={setCur} testId="cp-current" />
          <Field label="New password" type="password" value={nw} onChange={setNw} testId="cp-new" hint="At least 10 characters, one letter and one number." />
          <Field label="Confirm new password" type="password" value={conf} onChange={setConf} testId="cp-confirm" />
          <div className="flex gap-2 pt-2">
            <Button loading={busy} type="submit" testId="cp-submit">Update password</Button>
            {!mustChange && (
              <Button type="button" variant="ghost" onClick={() => nav("/admin")}>Cancel</Button>
            )}
            {mustChange && (
              <Button type="button" variant="ghost" onClick={async () => { await logout(); nav("/admin/login"); }}>Sign out</Button>
            )}
          </div>
        </form>
      </Card>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, hint, testId }) {
  return (
    <label className="block">
      <span className="mb-1.5 inline-block text-xs font-semibold uppercase tracking-[0.12em] text-slate-700">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        data-testid={testId}
        className="block w-full rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-[hsl(var(--aoa-royal))]"
      />
      {hint && <span className="mt-1 block text-[11px] text-slate-500">{hint}</span>}
    </label>
  );
}
